import { render, staticRenderFns } from "./car-configuration.vue?vue&type=template&id=5acce0e9&scoped=true&"
import script from "./car-configuration.vue?vue&type=script&lang=js&"
export * from "./car-configuration.vue?vue&type=script&lang=js&"
import style0 from "./car-configuration.vue?vue&type=style&index=0&id=5acce0e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acce0e9",
  null
  
)

export default component.exports